import { errorMessage, errorType } from "./AppConstant";

/**
 * エラーオブジェクト.
 *
 * @type {object}
 */
export const errorObject = {
  systemError: {
    error: {
      type: errorType.systemError,
      message: errorMessage.systemError,
    },
  },
  networkError: {
    error: {
      type: errorType.networkError,
      message: errorMessage.networkError,
    },
  },
  authError: {
    error: {
      type: errorType.authError,
      message: errorMessage.authError,
    },
  },
};

/**
 * エラーハンドリング
 *
 * @param {object} error エラー
 * @return {object} エラーオブジェクト
 */
export function handleError(error) {
  if (error.message && error.message.toUpperCase() === errorType.networkError) {
    // 通信エラーの場合
    return errorObject.networkError;
  }
  if (error.code === "NotAuthorizedException" || error === "No current user") {
    // 認証エラーの場合
    return errorObject.authError;
  }
  if (error.code === "LambdaTmpSizeOver") {
    // Lambda一時領域サイズ超過エラーの場合
    const formatSpace = "　　　";
    return {
      error: {
        type: errorType.lambdaTmpSizeOver,
        message: `フォルダのサイズが大きすぎて、少なくとも1件分(下記)のダウンロードに${formatSpace}失敗しました。下層のフォルダを選択し直し、ダウンロードしてください。${formatSpace}${formatSpace}(客先名：${error.label}、フォルダ名：${error.fileKey})`,
      },
    };
  }
  if (error.code === "S3PollingTimeout") {
    // S3ポーリングタイムアウトエラーの場合
    const formatSpace = "　　　　　　　　　　　";
    return {
      error: {
        type: errorType.s3PollingTimeout,
        message: `少なくとも1件分(下記)のダウンロードに失敗しました。${formatSpace}時間をおいて再度お試しください。${formatSpace}${formatSpace}(客先名：${error.label}、フォルダ名：${error.fileKey})`,
      },
    };
  }
  // その他エラーの場合
  return errorObject.systemError;
}

/**
 * GraphQLエラーハンドリング
 *
 * @param {object} error エラー
 * @return {object} エラーオブジェクト
 */
export function handleGraphqlError(error) {
  if (error.errors && error.errors.length) {
    // GraphQL APIエラーの場合
    switch (error.errors[0].errorType) {
      case "Unauthorized":
      case "UnauthorizedException":
        return errorObject.authError;

      default:
        if (
          error.errors[0].message &&
          error.errors[0].message.toUpperCase() === errorType.networkError
        ) {
          return errorObject.networkError;
        }
        return errorObject.systemError;
    }
  } else {
    // その他エラーの場合
    return handleError(error);
  }
}

/**
 * Promise Mapのエラーチェック.
 *
 * @param {object} responses Promise Mapのレスポンス
 * @return {object} エラーオブジェクト
 */
export function checkPromiseMapError(responses) {
  if (responses.error) {
    return responses.error;
  }
  const errorResponse = responses.find((response) => response.error);
  if (errorResponse && errorResponse.error) {
    return errorResponse.error;
  }
  return null;
}
